// import Swup from 'swup';
// import SwupScrollPlugin from '@swup/scroll-plugin';
// import SwupPreloadPlugin from '@swup/preload-plugin';
// import SwupBodyClassPlugin from '@swup/body-class-plugin';
import Archive from './components/archive';
import Cart from './components/cart';
import Header from './components/header';
import Newsletter from './components/newsletter';
import SingleProduct from './components/single_product';


// const options = {
//     containers: ["#container"],
//     debugMode: true,
//     plugins: [
//         new SwupPreloadPlugin(),
//         new SwupBodyClassPlugin(),
//         new SwupScrollPlugin({
//             doScrollingRightAway: false,
//             animateScroll: true,
//             scrollFriction: 0.3,
//             scrollAcceleration: 0.04
//         }),
//     ],
// }
// const swup = new Swup(options);
// swup.preloadPages();


function init() {
   // load content
    new Header();
    new Newsletter();
    new SingleProduct();
    new Archive();
    new Cart();
    
    window.addEventListener("pageshow", function (evt) {
        if (evt.persisted) {
            setTimeout(function () {
                window.location.reload();
            }, 1);
        }
    }, false);
}
// swup.on('contentReplaced', init);

// function unload() {}
// swup.on('willReplaceContent', unload);

function start(){
    // start content
    init();
}




document.addEventListener('load', start(), false);